import { Title } from "@mantine/core";

//

const AuthPrompt = () => <Title sx={{ textAlign: "center", fontWeight: 600, margin: "30vh 14px" }}>Login to view this Page...</Title>;

export default AuthPrompt;
